module.exports = __webpack_public_path__ + "img/eq-diadem.1a40b09f.png";